import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './content/locales/en.json';
import jaTranslation from './content/locales/ja.json';
import koTranslation from './content/locales/ko.json';
import zhTranslation from './content/locales/zh.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: enTranslation },
    ja: { translation: jaTranslation },
    ko: { translation: koTranslation },
    zh: { translation: zhTranslation },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
